import { ArrowLeftOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import {
  Button,
  Col,
  ContentBody,
  ContentHeader,
  Row,
  OpportunityForm,
  useAuthContext
} from '../../../core/components'

import useOrderCreate from '../../../services/mutations/useOrderCreate'
import useOpportunityCreate from '../../../services/mutations/useOpportunityCreate'
import { useImmer } from 'use-immer'
import { Product } from '../../../entities/product'

const opportunityDefaultValue = {
  businessUnityId: '',
  customerId: '',
  sellerId: '',
  marketId: '',
  situationId: '10',
  contacterId: '',
  contact: '',
  status: 'E',
  nextContact: '',
  salesForecast: '',
  proposalValidity: '',
  eventId: '',
  conceptId: '',
  orderId: ''
  // campaignId: ''
}

const orderDefaultValues = {
  customerId: '',
  salesmanId: '',
  paymentMethodId: '',
  budgetId: '',
  paymentTermId: '',
  businessUnitId: '',
  shippingType: '0',
  statusId: '10',
  invoiceType: 'N',
  total: '',
  approved: 0,
  canceled: 0,
  observation: '',
  deliveryDate: '',
  approvedDate: '',
  priceTableId: '',
  items: []
}

const formDefaultValues = {
  opportunity: opportunityDefaultValue,
  order: orderDefaultValues,
  temp: { address: '' }
}

export const CreateOpportunityPage = () => {
  const { goBack } = useHistory()
  const { user } = useAuthContext()

  const [formValues, setFormValues] = useImmer(formDefaultValues)

  const { mutateAsync: orderMutate, reset: orderReset } = useOrderCreate()
  const { mutateAsync: opportunityMutate } = useOpportunityCreate()

  const handleSubmit = async () => {
    if (formValues.order.items.length > 0 && formValues.order.paymentMethodId) {
      const items = formValues.order.items.map(
        (item: Product, index: number) => ({
          ...item,
          sequence: index + 1,
          productId: item.id,
          quantity: 1,
          salePrice: item.price,
          defaultPrice: item.price,
          priceListId: '',
          discountPercent: 0
        })
      )
      const orderID = await orderMutate({
        ...formValues.order,
        items,
        salesmanId: user?.id || '',
        customerId: formValues.opportunity.customerId,
        businessUnitId: formValues.opportunity.businessUnityId,
        total: formValues.order.items?.reduce(
          (acc: any, cur: any) => acc + cur.price,
          0
        )
      })

      await opportunityMutate({
        ...formValues.opportunity,
        contacterId: user?.id || '',
        sellerId: user?.id || '',
        orderId: orderID?.data || ''
      })
    } else {
      await opportunityMutate({
        ...formValues.opportunity,
        contacterId: user?.id || '',
        sellerId: user?.id || ''
      })
    }
    orderReset()
    goBack()
    setFormValues(formDefaultValues)
  }

  return (
    <>
      <ContentHeader>
        <Button type="text" onClick={goBack}>
          <ArrowLeftOutlined />
        </Button>
        Nova Oportunidade
      </ContentHeader>
      <ContentBody>
        <div>
          <OpportunityForm values={formValues} setValues={setFormValues} />
          <Row gutter={24} style={{ marginTop: 20 }}>
            <Col span={24}></Col>
            <Col>
              <Button
                htmlType="submit"
                type="primary"
                onClick={handleSubmit}
                style={{ width: 150 }}
              >
                Cadastrar
              </Button>
            </Col>
            <Col>
              <Button
                htmlType="reset"
                onClick={() => setFormValues(formDefaultValues)}
                type="default"
              >
                Reiniciar
              </Button>
            </Col>
          </Row>
        </div>
      </ContentBody>
    </>
  )
}
